import { render, staticRenderFns } from "./DualAxisParamComparisonPanel.vue?vue&type=template&id=248161c4&scoped=true"
import script from "./DualAxisParamComparisonPanel.vue?vue&type=script&lang=js"
export * from "./DualAxisParamComparisonPanel.vue?vue&type=script&lang=js"
import style0 from "./DualAxisParamComparisonPanel.vue?vue&type=style&index=0&id=248161c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248161c4",
  null
  
)

export default component.exports